<script lang="ts">
export const elSpinnerSize = ['normal', 'larger'] as const;
export type ElSpinnerSize = (typeof elSpinnerSize)[number];
</script>

<script lang="ts" setup>
import { onDeactivated, onMounted, ref } from 'vue';

const props = withDefaults(
  defineProps<{
    label?: string;
    size?: ElSpinnerSize;
    extraLoadingMsgAfterSeconds?: number;
  }>(),
  {
    label: '',
    size: 'normal',
    extraLoadingMsgAfterSeconds: -1,
  },
);

// it will hold the nodejs timer
const extraMsgTimer: any = ref(null);
const extraLabelAppend = ref('');

onMounted(() => {
  if (props.extraLoadingMsgAfterSeconds && props.extraLoadingMsgAfterSeconds > 0) {
    extraMsgTimer.value = setTimeout(() => {
      extraLabelAppend.value += ' Connessione lenta, ancora qualche secondo...';
    }, props.extraLoadingMsgAfterSeconds * 1000);
  }
});

onDeactivated(() => {
  clearTimeout(extraMsgTimer);
});
</script>

<template>
  <span class="text-neutral-darker flex items-center">
    <svg
      class="text-neutral-darker h-4 w-4 animate-spin"
      :class="{ 'mr-3': label, '!h-12 !w-12': size === 'larger' }"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
    <span v-if="label">{{ label }} {{ extraLabelAppend }}</span>
  </span>
</template>
